var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('action-sidebar',{attrs:{"title":_vm.title,"value":true,"width":450},on:{"close-modal":_vm.closeModal}},[_c('cost-center-form',{attrs:{"id":_vm.id,"father-id":_vm.fatherId,"code":_vm.code,"level":_vm.level,"is-edit":_vm.isEdit},on:{"on-close":_vm.closeModal}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ec6dcc3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/cost-centers/page-cost-center-new.vue
// module id = 1427
// module chunks = 6